import { BehaviorSubject } from "rxjs";
import { handleJsonResponse, requestApi } from "../api/apiUtils";

// Safely parse CurrentUser from localStorage
const getInitialUser = () => {
    try {
        const storedUser = localStorage.getItem("CurrentUser");
        return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
        console.error("Failed to parse CurrentUser from localStorage:", error);
        return null;
    }
};

const CurrentUserSubject = new BehaviorSubject(getInitialUser());

export const AuthenticationService = {
    changePassword,
    forgotPassword,
    resetPassword,
    CurrentUser: CurrentUserSubject.asObservable(),

    get CurrentWorker() {
        return CurrentUserSubject.value?.WorkerId ?? 0;
    },
    get CurrentCompany() {
        return CurrentUserSubject.value?.CompanyId ?? 0;
    },
    get CurrentUserId() {
        return CurrentUserSubject.value?.UserId ?? "";
    },
    get CurrentUserToken() {
        return CurrentUserSubject.value?.SecurityToken ?? "";
    },
    get IsAuthenticated() {
        return !!CurrentUserSubject.value;
    },
    get IsExternalLogin() {
        return CurrentUserSubject.value?.ExternalLogin ?? false;
    },
};

async function changePassword(
    UserId: string,
    CurrentPassword: string,
    NewPassword: string
) {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${AuthenticationService.CurrentUserToken}`,
        },
        body: JSON.stringify({ UserId, CurrentPassword, NewPassword }),
    };

    try {
        const response = await fetch(
            requestApi("/Authentication/ChangePassword"),
            requestOptions
        );
        return await handleJsonResponse(response);
    } catch (error) {
        console.error("Change password failed:", error);
        throw error;
    }
}

async function forgotPassword(UserId: string, Language: string) {
    const SkipConfirmation = false;
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ UserId, Language, SkipConfirmation }),
    };

    try {
        const response = await fetch(
            requestApi("/Authentication/RequestPasswordReset"),
            requestOptions
        );
        return await handleJsonResponse(response);
    } catch (error) {
        console.error("Forgot password failed:", error);
        throw error;
    }
}

async function resetPassword(
    UserId: string,
    ResetToken: string,
    NewPassword: string
) {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ UserId, ResetToken, NewPassword }),
    };

    try {
        const response = await fetch(
            requestApi("/Authentication/ResetPassword"),
            requestOptions
        );
        return await handleJsonResponse(response);
    } catch (error) {
        console.error("Reset password failed:", error);
        throw error;
    }
}